import SpinnerSVG from "./SpinnerSVG"
import classes from "./SpinningLoader.module.css"

const SpinnerLoader: React.FC = () => (
  <div className={classes.container}>
    <SpinnerSVG />
  </div>
)

export default SpinnerLoader
